import {
  MERCHANT_SUMMARY_FAILD,
  MERCHANT_SUMMARY_LOADING,
  MERCHANT_SUMMARY_SUCCESS,
} from "../types";

const initialState = {
  merchantSummary: null,
  loading: false,
  error: null,
};

export const merchantSummaryReducer = (
  state = initialState,
  action: { type: any; loading: any; payload: any; error: any }
) => {
  switch (action.type) {
    case MERCHANT_SUMMARY_LOADING:
      return {
        ...state,
        loading: action.loading,
        error: null,
      };
    case MERCHANT_SUMMARY_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        merchantSummary: action.payload,
      };
    case MERCHANT_SUMMARY_FAILD:
      return {
        ...state,
        loading: false,
        error: action.error,
      };

    default:
      return state;
  }
};
